import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserInfoService } from '../UserInfo/user-info.service';
import { logout } from 'src/app/core/auth/store/actions/auth.action';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { City } from 'src/app/core/cities/models/cities.model';
import { CitiesService } from 'src/app/core/cities/services/cities.service';
import { PendingMessagesService } from 'src/app/core/chat/services/pending-messages.service';
import { Router } from '@angular/router';
import { ChatService } from 'src/app/features/chat/services/chat.service';
import * as ordersActions from 'src/app/core/orders/store/actions/orders.action';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  isExpanded = false;
  userInfo: any;
  userRoleId: number | null = null;
  selectedOption: string; 
  cities: any;
  selectedCity: any;
  private cityChangeSubscription: Subscription;
  private pendingMessagesSubscription: Subscription; 
  pendingMessages: { service_id: number; count: number }[] = []; 


  constructor(
    private userInfoService: UserInfoService, 
    private store: Store,
    private citiesService: CitiesService,
    private pendingMessagesService: PendingMessagesService,
    private router: Router,
    public chatService: ChatService
  ) {
    
  }

  ngOnInit() {
    this.userInfo = this.userInfoService.getUserInfo();
    this.cities = this.citiesService.getCities();
    this.selectedCity = this.citiesService.getUserSelectedCity();
    this.userRoleId = this.userInfoService.getRoleId();
    this.cityChangeSubscription = this.citiesService.cityChange$.subscribe(city => {
      window.location.reload();
    });

    this.pendingMessagesSubscription = this.pendingMessagesService.getPendingMessages().subscribe(messages => {
    this.pendingMessages = messages;
     
    });
  }

    ngOnDestroy() {
      if (this.cityChangeSubscription) {
        this.cityChangeSubscription.unsubscribe();
      }
      if (this.pendingMessagesSubscription) {
        this.pendingMessagesSubscription.unsubscribe();
      }
    }

  
  toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  logout() {
    this.store.dispatch(logout());
  }

  setSelectedCity(city: City) {
    this.citiesService.setUserSelectedCity(city); 
  }

  navigateToChat(service_id: number) {
    this.router.navigate(['/orders-support']);
    this.store.dispatch(ordersActions.currentOrderId({ id: service_id }));
    this.chatService.toggleChat();
  }
}

